import AuthGenderInputComponent from "./AuthGenderInputComponent";

export default AuthGenderInputComponent;
